interface FocusPointPickerProps {
  imageUrl: string
  focusX: number
  focusY: number
  onChange: (x: number, y: number) => void
}

export function FocusPointPicker({ imageUrl, focusX, focusY, onChange }: FocusPointPickerProps) {
  function handleClick(e: React.MouseEvent<HTMLDivElement>) {
    const rect = e.currentTarget.getBoundingClientRect()
    const x = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width))
    const y = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height))
    onChange(x, y)
  }

  return (
    <div className="space-y-2">
      <p className="text-xs text-muted-foreground">
        Click on the image to set the focus point. This area will stay visible at all screen sizes.
      </p>
      <div
        className="relative overflow-hidden rounded-lg border cursor-crosshair select-none bg-muted/30"
        onClick={handleClick}
      >
        <img
          src={imageUrl}
          alt="Focus point picker"
          className="block h-auto w-full max-h-[60vh] object-contain pointer-events-none"
          draggable={false}
        />
        {/* Focus pin */}
        <div
          className="absolute pointer-events-none"
          style={{
            left: `${focusX * 100}%`,
            top: `${focusY * 100}%`,
            transform: 'translate(-50%, -50%)',
          }}
        >
          <div className="h-5 w-5 rounded-full border-2 border-white bg-brand-orange shadow-md" />
        </div>
        {/* Crosshair lines */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: `
              linear-gradient(to right, transparent calc(${focusX * 100}% - 0.5px), rgba(255,255,255,0.5) calc(${focusX * 100}% - 0.5px), rgba(255,255,255,0.5) calc(${focusX * 100}% + 0.5px), transparent calc(${focusX * 100}% + 0.5px)),
              linear-gradient(to bottom, transparent calc(${focusY * 100}% - 0.5px), rgba(255,255,255,0.5) calc(${focusY * 100}% - 0.5px), rgba(255,255,255,0.5) calc(${focusY * 100}% + 0.5px), transparent calc(${focusY * 100}% + 0.5px))
            `,
          }}
        />
      </div>
      <p className="text-[10px] text-muted-foreground text-right">
        Focus: {Math.round(focusX * 100)}% × {Math.round(focusY * 100)}%
      </p>
    </div>
  )
}
